<template>
  <v-chip
    :class="chipClasses"
    :outlined="variant === 'outlined'"
    :color="chipVuetifyColor"
    :style="tonalColorStyle"
    :disabled="disabled"
    :small="small"
    label
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </v-chip>
</template>

<script>
export default {
  name: 'Chip',

  inheritAttrs: false,

  props: {
    variant: {
      type: String,
      default: 'outlined',
      validator: (value) => ['outlined', 'tonal', 'filled'].includes(value)
    },
    tonalColor: {
      type: String,
      default: 'primary',
      validator: (value) =>
        ['primary', 'success', 'warning', 'error', 'grey', 'info'].includes(value) ||
        /^#[0-9A-Fa-f]{6,8}$/.test(value)
    },
    filledColor: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'success', 'warning', 'error'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outlineColor: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'success', 'warning', 'error'].includes(value)
    },
    iconOnly: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isTonalColorHex() {
      return /^#[0-9A-Fa-f]{6,8}$/.test(this.tonalColor);
    },
    tonalColorStyle() {
      if (this.variant !== 'tonal' || !this.isTonalColorHex) return {};

      return {
        color: this.tonalColor,
        backgroundColor: `${this.tonalColor}1A`
      };
    },
    chipClasses() {
      const classes = ['chip-cambio'];

      if (this.variant === 'tonal') {
        if (!this.isTonalColorHex) {
          classes.push('chip-tonal');
          classes.push(`chip-tonal-${this.tonalColor}`);
        }
      } else if (this.variant === 'filled') {
        classes.push('chip-filled');
        classes.push(`chip-filled-${this.filledColor}`);
      }

      if (this.iconOnly) {
        classes.push('chip-icon-only');
      }

      if (this.small) {
        classes.push('chip-cambio--small');
      }

      return classes;
    },
    chipVuetifyColor() {
      if (this.variant === 'outlined') {
        return this.outlineColor;
      }

      if (this.variant === 'filled') {
        return undefined;
      }

      return undefined;
    }
  }
};
</script>

<style scoped>
.chip-cambio >>> .v-chip__content {
  color: inherit;
}
</style>
